var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 700 800",
    style: {
      enableBackground: "new 0 0 700 800"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#000080;}\n\t.st1{fill:none;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M156.89,369.2c-3.18,6.13-7.83,12.71-12.85,19.06L38,192.52l160.53-5.32l36.81,73.77 c-36.79,21.2-93.23,63.9-93.23,63.9l22.16,7.39c-5.98,5.98-14.78,20.98-23.05,36.64C139.97,371.34,158.14,366.76,156.89,369.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M662,191.29L554.71,386.78c-4.66-5.84-8.87-11.97-11.75-17.58c-1.26-2.44,16.92,2.14,15.66-0.3 c-8.35-15.66-17.06-30.66-23.05-36.64l22.16-7.39c0,0-56.88-43-93.68-64.12l36.66-69.9L662,191.29z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 241.18,
    y1: 272.71,
    x2: 235.34,
    y2: 260.97
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M519.6,361.81h22.31c-14.77-22.16-38.34-44.33-38.34-44.33h16.18c0,0-44.18-36.86-62.13-44.77l-0.03,0.04 c-11.13-5.48-23.29-5.78-35.41-3.67c12.21-6.63,27.24-7.33,27.24-7.33c-36.92-9.22-59.23,10.33-67.51,20.07 c0,0.06-0.06,0.06-0.06,0.06c-0.23,0.12-0.53,0.18-0.76,0.3c-2.11-2.82,3.76-14.56,8.63-19.85c-28.35,5.29-40.32,25.66-40.32,25.66 s-11.97-20.37-40.32-25.66c4.87,5.29,10.74,17.03,8.63,19.85c-0.23-0.12-0.53-0.18-0.76-0.3c0,0-0.06,0-0.06-0.06 c-8.28-9.74-30.59-29.29-67.51-20.07c0,0,15.03,0.7,27.24,7.33c-12.12-2.11-24.28-1.81-35.41,3.67l-0.03-0.04 c-17.95,7.91-62.13,44.77-62.13,44.77h16.18c0,0-23.57,22.17-38.34,44.33h22.31l-33.32,29.77L349.4,760.74l203.52-369.16 L519.6,361.81z M371.09,599.94l-7.12-12.91L349.7,625.8l-17.52-40.92l-6.07,13.61l-16.32-28.37l39.91-25.19l39.9,25.19 L371.09,599.94z M476.38,418.27c4.36,20.43-4.29,41.44-21.78,52.88l-31.45,20.56l14.79,19.07c10.99,14.16,8.08,34.61-6.43,45.15 l-17.79,12.91l-57.04-36.01v-35.11l25.8-17.11c2.33-1.55,1.23-5.18-1.56-5.18h-62.44c-2.79,0-3.89,3.63-1.56,5.18l25.8,17.11v35.11 l-57.04,36.01l-17.79-12.91c-14.51-10.54-17.43-30.99-6.44-45.15l14.8-19.07l-31.46-20.56c-17.48-11.44-26.13-32.45-21.77-52.88 l7.49-35.09L211.9,363.8l30.14-40.45c16.51-22.15,46.81-28.78,71.06-15.54l36.6,19.98l36.6-19.98 c24.25-13.24,54.55-6.61,71.06,15.54l30.13,40.45l-18.6,19.38L476.38,418.27z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M309.06,393.94l-69.06-10.76l32.46,28.62c2.26,1.99,5.32,2.8,8.27,2.18l21.29-4.45l15.12,40.31v-46.48 C317.14,398.67,313.71,394.66,309.06,393.94z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M382.26,403.37v46.48l15.12-40.31l21.29,4.45c2.95,0.62,6.01-0.19,8.27-2.18l32.46-28.62l-69.06,10.76 C385.69,394.66,382.26,398.67,382.26,403.37z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "530.07,97.09 515.05,103.28 457.58,126.98 444.1,132.54 351.88,170.56 261.22,135.26 245.93,129.31  245.91,129.31 189.78,107.44 175.24,101.78 347.19,39.26  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M352.01,180.47l76.95-31.72v26.06l-60.62,30.35c-10.31,5.16-22.43,5.3-32.85,0.37l-59.13-27.95v-26.56 L352.01,180.47z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M428.96,148.75v26.06l-60.62,30.35c-10.31,5.16-22.43,5.3-32.85,0.37l-59.13-27.95v-26.56l75.65,29.45 L428.96,148.75z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "203.11,134.73 181.86,171.54 224.36,171.54  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 201.64,
    y: 111.43,
    className: "st0",
    width: 2.94,
    height: 38.03
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.070567ea1b708e95296e23eab0c8a285.svg";
export { ForwardRef as ReactComponent };